import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './services/auth'; // 注册 AuthApiPort 注入，使 authStore 联网
import { useAuthStore } from './store/authStore';
import './styles/global.css';

// 应用启动时从 localStorage 恢复会话，保证刷新后保持登录态。
useAuthStore.getState().restoreSession();

// 应用入口：挂载根组件到 #root。
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
